import React, { useState } from "react"
import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"

import FallBackImage from "../../images/wdn-avatar-placeholder.png"
import Cross from "../../images/icons/wdn-cross.png"

import HoverMenu from "./hover-menu"
import {
  CANDIDATE_JOB_MENU,
  COMPANY_JOB_MENU,
  COMPANY_SIDEBAR_MENU_STEP,
  SIDEBAR_MENU_STEP,
} from "../../constants/sidebar-menu"
import { getBaseAddress } from "../../utils/getBaseAddress"
import Icons from "./icons"
import Header from "../new-home/header"

export default function PrimaryMenu({
  state,
  handleLogoutClick,
  isMenuOpen,
  active,
  hide,
  Ham,
  handleHamClick,
}) {
  const [menuOpen, setMenuOpen] = useState("")
  const sma = [{ ID: 3, title: "Logout", slug: "logout" }]

  const primary_menu = state.primary_menu

  let secondary_menu

  // if (state.isAuthenticated && state.isEmailVerified) {
  //   secondary_menu = sma
  // } else if (state?.isAuthenticated && !state?.isEmailVerified) {
  //   secondary_menu = sma
  // } else if (!state.isAuthenticated) {
  //   secondary_menu = state.secondary_menu
  // } else {
  //   secondary_menu = state.secondary_menu
  // }

  const menuItemsAvatar = [
    {
      name: "Settings",
      link: `${
        state?.user?.candidate?.id ? "/candidate" : "/company"
      }/profile/settings/change-password`,
    },
    { name: "Logout", handler: "logout" },
  ]

  const menuItems = [
    { name: "Dashboard", link: "/profile/dashboard" },
    {
      name: "Profile",
      childrens: !!state?.user?.candidate?.id
        ? SIDEBAR_MENU_STEP
        : COMPANY_SIDEBAR_MENU_STEP,
    },

    {
      name: "Jobs",
      childrens: !!state?.user?.candidate?.id
        ? CANDIDATE_JOB_MENU
        : COMPANY_JOB_MENU,
    },
    {
      name: "CVs",
      childrens: [
        {
          name: "Shortlisted",
          count: state?.company_counts?.shortlist,
          link: "/company/profile/shortlist",
        },
        {
          name: "Cart",
          count: state?.company_counts?.cart,
          link: "/company/profile/cart",
        },
        {
          name: "Paid CVs",
          count: state?.company_counts?.paidcvs,
          link: "/company/profile/paid-cvs",
        },
      ],
    },
    {
      name: "Settings",
      class: "show-in-mobile",
      link: "/profile/settings/change-password",
    },
  ]

  const handleMenuOpen = menu => {
    if (menu === menuOpen) {
      setMenuOpen("")
      return
    }
    setMenuOpen(menu)
  }

  return (
    <>
      <nav className="text-right p-0">
        <Row className={isMenuOpen ? "show navbar text-right" : "navbar "}>
          <a
            href="#"
            className={
              (isMenuOpen ? "show nav_toggle_mobile" : "nav_toggle_mobile") +
              " position-absolute"
            }
            onClick={handleHamClick}
          >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <img src={Cross} alt="" />
          </a>
          {!hide && !state?.hasProfile && (
            <Col lg="8 ">
              <ul className="auth-nav-items primary-menu">
                {primary_menu?.map(menu => (
                  <li
                    key={menu.ID}
                    className=" auth-nav-item mr-4 border-bottom-custom"
                  >
                    <Link activeClassName="active" to={`/${menu.slug}`}>
                      {menu.title}
                    </Link>
                  </li>
                ))}

                {secondary_menu?.map((menu, index) => (
                  <Link
                    activeClassName="active"
                    to={`/${menu.slug}`}
                    key={menu.slug}
                    className={
                      (index === 0 ? "first-button " : "") + " show-in-mobile"
                    }
                  >
                    <li
                      key={menu.ID}
                      className={
                        (index % 2 !== 0
                          ? "blue-outline "
                          : "blue-background  rounded  ") +
                        " btn btn-custom btn-block py-2 text-center mt-3 d-block"
                      }
                    >
                      {menu.title}
                    </li>
                  </Link>
                ))}
              </ul>
            </Col>
          )}
          {state?.isAuthenticated && state?.hasProfile && (
            <Col lg={hide ? "12 pr-0" : "4 pr-0"} className="text-right ">
              <ul className=" auth-nav-items">
                {menuItems?.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.link ? (
                      <li
                        key={item.link + index}
                        className={
                          item.class +
                          " auth-nav-item mr-4 border-bottom-custom"
                        }
                      >
                        <Link
                          activeClassName="active"
                          to={getBaseAddress(state) + item.link}
                        >
                          <span className="mr-1">{item.name}</span>
                        </Link>
                      </li>
                    ) : item.name === "CVs" && !!state?.user?.candidate?.id ? (
                      <></>
                    ) : (
                      <li
                        key={index}
                        className={
                          item.name === menuOpen
                            ? "show-hover-menu mr-4 border-bottom-custom"
                            : " mr-4 border-bottom-custom"
                        }
                      >
                        <button
                          className=" btn no-border background-transparent text-left"
                          onMouseEnter={() => handleMenuOpen(item.name)}
                          onMouseLeave={() => handleMenuOpen("")}
                        >
                          <div className="menu-header">
                            <span className="mr-1">{item.name}</span>
                            <span className="arrow-down-menu "></span>
                          </div>
                          {menuOpen === item.name && (
                            <HoverMenu
                              noBackdrop
                              handleLogoutClick={handleLogoutClick}
                              setMenuOpen={setMenuOpen}
                              menu={item.childrens}
                            />
                          )}
                        </button>
                      </li>
                    )}
                  </React.Fragment>
                ))}
                <li className="hide-in-mobile ">
                  <Icons state={state} />
                </li>

                <li
                  className={
                    "avatar" === menuOpen
                      ? "show-hover-menu hide-in-mobile"
                      : " hide-in-mobile "
                  }
                >
                  <button
                    className="no-border background-transparent"
                    onClick={() => handleMenuOpen("avatar")}
                  >
                    <span className="d-inline-block mr-1">
                      <div className="header-profile-avatar ">
                        <img
                          src={
                            !!state?.profile?.avatar
                              ? state?.profile?.avatar
                              : FallBackImage
                          }
                          className="avatar"
                          alt=""
                        />
                      </div>
                    </span>
                    <span className="arrow-down-menu"></span>
                  </button>
                  {menuOpen === "avatar" && (
                    <HoverMenu
                      handleLogoutClick={handleLogoutClick}
                      setMenuOpen={setMenuOpen}
                      menu={menuItemsAvatar}
                    />
                  )}
                </li>

                <li className="show-in-mobile first-button">
                  <button
                    className="btn btn-custom rounded blue-background btn-primary btn-block py-2 no-border"
                    onClick={handleLogoutClick}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </Col>
          )}
          {(!state?.isAuthenticated || !state?.hasProfile) && (
            <Col
              lg={!state?.isAuthenticated ? "4 pr-0" : "4 offset-lg-8 pr-0"}
              className={
                state?.isAuthenticated
                  ? "no-profile-menu hide-in-mobile"
                  : "hide-in-mobile"
              }
            >
              {secondary_menu?.map((menu, index) => (
                <li
                  key={menu.ID}
                  className={
                    index + 1 === secondary_menu?.length
                      ? "navbar__item no-border"
                      : "navbar__item pr-3"
                  }
                >
                  {menu.slug !== "logout" && (
                    <Link to={`/${menu.slug}`} activeClassName="active">
                      {menu.title}
                    </Link>
                  )}
                  {menu.slug === "logout" && (
                    <button
                      className="btn no-background text-strong p-0 black no-border"
                      onClick={handleLogoutClick}
                    >
                      {menu.title}
                    </button>
                  )}
                </li>
              ))}
            </Col>
          )}
        </Row>
        {state?.isAuthenticated && state?.hasProfile && (
          <span className="show-in-mobile">
            <Icons state={state} />
          </span>
        )}
        <span className="navbar__toggler">
          <img src={Ham} onClick={handleHamClick} alt="" />
        </span>
      </nav>
    </>
  )
}
